import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */
/* @jsx mdx */
import DefaultLayout from "/vercel/path0/node_modules/gatsby-theme-docz/src/base/Layout.js";
export const _frontmatter = {};
const layoutProps = {
  _frontmatter
};
const MDXLayout = DefaultLayout;
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">


    <h2 {...{
      "id": "bitpay"
    }}>{`BitPay`}</h2>
    <p>{`BitPay is a bitcoin payment service provider headquartered in Atlanta, Georgia, United States. It was founded in May 2011 by Tony Gallippi and Stephen Pair. BitPay provides Bitcoin and Bitcoin Cash payment processing services for merchants.`}</p>
    <blockquote>
      <p parentName="blockquote">{`Before integrate BitPay check the list that your country is not restricted. `}<a parentName="p" {...{
          "href": "https://support.bitpay.com/hc/en-us/articles/360000123366-Why-can-t-I-use-BitPay-s-services-in-my-country"
        }}>{`Restricted Country List`}</a></p>
    </blockquote>
    <h3 {...{
      "id": "bitpay-integrate-inside-pixer"
    }}>{`BitPay integrate inside Pixer.`}</h3>
    <p>{`Please follow & complete this steps for BitPay integration for your e-commerce system.`}</p>
    <ul>
      <li parentName="ul">{`Inside `}<inlineCode parentName="li">{`.env`}</inlineCode>{` file copy & paste this line of codes. We will discuss later about how to create those API keys in BitPay.`}</li>
    </ul>
    <pre><code parentName="pre" {...{}}>{`# \`BITPAY_IS_PRODUCTION\` value either true or false
BITPAY_IS_PRODUCTION=false

# Set any password you want that will use for encrypting your private key
BITPAY_KEY_STORAGE_PASSWORD=[LONG_SECRET]

# This is used for generating your token.
BITPAY_ENABLE_MERCHANT=true
BITPAY_ENABLE_PAYOUT=false

# This is important generating your json or yml file 
BITPAY_GENERATE_JSON_FILE=true
BITPAY_GENERATE_YML_FILE=false

# All Files are located \`storage/app/private/\`. Which will use for initiating you BITPAY client.
 
SHOP_URL=[YOUR_SHOP_URL]
`}</code></pre>
    <b>SHOP_URL=[YOUR_SHOP_URL]</b> This parameter is must have in .env file when BitPay is using. Otherwise the payment redirection will be broken.
    <ul>
      <li parentName="ul">{`Activate BitPay from Pixer admin dashboard. (e.g. webhook URL is coming from local development. This static link will dynamically generated in live environment)`}</li>
    </ul>
    <p><img alt="paypal-Pixer-dashboard" src={require("../images/payment-images/bitpay_payment_webhook.png")} /></p>
    <h2 {...{
      "id": "how-to-create--setup-bitpay-information-properly"
    }}>{`How to create & setup BitPay information properly?`}</h2>
    <ul>
      <li parentName="ul">
        <p parentName="li">{`Create an account in `}<a parentName="p" {...{
            "href": "https://bitpay.com/authenticate/signup?business"
          }}>{`https://bitpay.com/authenticate/signup?business`}</a></p>
      </li>
      <li parentName="ul">
        <p parentName="li">{`Choose sandbox if your are testing your development environment signup in here `}<a parentName="p" {...{
            "href": "https://test.bitpay.com/authenticate/signup"
          }}>{`https://test.bitpay.com/authenticate/signup`}</a>{`.`}</p>
      </li>
      <li parentName="ul">
        <p parentName="li">{`Now go to the terminal run `}<inlineCode parentName="p">{`php artisan marvel:generate_bitpay_config`}</inlineCode>{` to generate your private key and config file`}</p>
      </li>
      <li parentName="ul">
        <p parentName="li">{`You will find an output like below, With some instructions.`}</p>
      </li>
    </ul>
    <p><img alt="bitpay_config_generator" src={require("../images/payment-images/bitpay_config_generator.png")} /></p>
    <ul>
      <li parentName="ul">{`You can approve the API Token by logon to that url, or just copy The ParingCode and goto your bitpay merchant account's dashboard. Go to Payment Tools find API TOKEN section paste Paring Code there. Then find and approve it. `}</li>
    </ul>
    <p><img alt="bitpay_dashboard_api_token" src={require("../images/payment-images/bitpay_dashboard_api_token.png")} /></p>
    <p><img alt="bitpay_dashboard_api_approve" src={require("../images/payment-images/test_bitpay_token_approve.png")} /></p>
    <blockquote>
      <p parentName="blockquote">{`Webhook is most import thing to manage payments status with bitpay setup.`}</p>
    </blockquote>
    <ul>
      <li parentName="ul">
        <p parentName="li">{`Available Webhooks Status.`}</p>
        <ul parentName="li">
          <li parentName="ul">
            <b>new</b>
          </li>
          <li parentName="ul">
            <b>paid</b>
          </li>
          <li parentName="ul">
            <b>confirmed</b>
          </li>
          <li parentName="ul">
            <b>complete</b>
          </li>
          <li parentName="ul">
            <b>expired</b>
          </li>
          <li parentName="ul">
            <b>invalid</b>
          </li>
        </ul>
      </li>
      <li parentName="ul">
        <p parentName="li">{`At last, For going live with your application please follow this official documentation. `}<a parentName="p" {...{
            "href": "https://github.com/bitpay/php-bitpay-client-v2"
          }}>{`https://github.com/bitpay/php-bitpay-client-v2`}</a>{` and `}<a parentName="p" {...{
            "href": "https://test.bitpay.com/api/"
          }}>{`https://test.bitpay.com/api/`}</a></p>
      </li>
    </ul>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      